/// Enum đánh dấu là CT hạch toán lương/ bảo hiểm
export default {
    Salary: 1,
    Insurance: 0,
}